module.exports = __webpack_public_path__ + "static/media/fhs-rewards-inactive.32bacb95.png";